import { random, round2Str } from "../helpers/helpers";
import { aqiMeterRegistry } from "./aqiMeterRegistry";

export const generateAqiIndoorChartMonthDemo = ({
    meter_id,
    year,
    month,
}) => {
    const meter = aqiMeterRegistry.find(
        (m) => m.meter_id === Number(meter_id)
    );

    if (!meter) {
        return {
            daily_energy_data: [],
            month: Number(month),
            year: Number(year),
        };
    }

    const { ranges } = meter;

    const now = new Date();
    const isCurrentMonth =
        now.getFullYear() === Number(year) &&
        now.getMonth() + 1 === Number(month);

    const daysInMonth = new Date(year, month, 0).getDate();
    const lastDay = isCurrentMonth ? now.getDate() : daysInMonth;

    // Smooth base values
    let baseTemp = random(ranges.temperature[0], ranges.temperature[1]);
    let baseHum = random(ranges.humidity[0], ranges.humidity[1]);
    let baseCo = random(ranges.co[0], ranges.co[1]);
    let basePm2 = random(ranges.pm2[0], ranges.pm2[1]);
    let basePm10 = random(ranges.pm10[0], ranges.pm10[1]);

    const daily_energy_data = [];

    for (let day = 1; day <= lastDay; day++) {

        // Smooth drift
        baseTemp += random(-0.2, 0.2);
        baseHum += random(-1.2, 1.2);
        baseCo += random(-80, 120);
        basePm2 += random(-5, 5);
        basePm10 += random(-10, 10);

        // Clamp base values
        baseTemp = Math.min(Math.max(baseTemp, ranges.temperature[0]), ranges.temperature[1]);
        baseHum = Math.min(Math.max(baseHum, ranges.humidity[0]), ranges.humidity[1]);
        baseCo = Math.min(Math.max(baseCo, ranges.co[0]), ranges.co[1]);
        basePm2 = Math.min(Math.max(basePm2, ranges.pm2[0]), ranges.pm2[1]);
        basePm10 = Math.min(Math.max(basePm10, ranges.pm10[0]), ranges.pm10[1]);

        const minTemp = Math.max(baseTemp - random(0.3, 1.0), ranges.temperature[0]);
        const maxTemp = Math.min(baseTemp + random(0.3, 1.0), ranges.temperature[1]);

        const minHum = Math.max(baseHum - random(2, 6), ranges.humidity[0]);
        const maxHum = Math.min(baseHum + random(2, 6), ranges.humidity[1]);

        const minCo = Math.max(baseCo - random(80, 250), ranges.co[0]);
        const maxCo = Math.min(baseCo + random(150, 500), ranges.co[1]);

        const minPm2 = Math.max(basePm2 - random(5, 15), ranges.pm2[0]);
        const maxPm2 = Math.min(basePm2 + random(5, 15), ranges.pm2[1]);

        const minPm10 = Math.max(basePm10 - random(10, 25), ranges.pm10[0]);
        const maxPm10 = Math.min(basePm10 + random(10, 25), ranges.pm10[1]);

        daily_energy_data.push({
            day: day,

            avg_temp: round2Str(baseTemp),
            min_temp: round2Str(minTemp),
            max_temp: round2Str(maxTemp),

            avg_humidity: round2Str(baseHum),
            min_humidity: round2Str(minHum),
            max_humidity: round2Str(maxHum),

            avg_co: round2Str(baseCo),
            min_co: round2Str(minCo),
            max_co: round2Str(maxCo),

            avg_tvoc: round2Str(0),
            min_tvoc: round2Str(0),
            max_tvoc: round2Str(0),

            avg_formaldehyde: round2Str(0),
            min_formaldehyde: round2Str(0),
            max_formaldehyde: round2Str(0),

            avg_pm2: round2Str(basePm2),
            min_pm2: round2Str(minPm2),
            max_pm2: round2Str(maxPm2),

            avg_pm10: round2Str(basePm10),
            min_pm10: round2Str(minPm10),
            max_pm10: round2Str(maxPm10),
        });
    }

    return {
        daily_energy_data,
        month: Number(month),
        year: Number(year),
    };
};